import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UpdateExternalTeacherBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const updateExternalTeacher = createAsyncThunk<void, UpdateExternalTeacherBody, { extra: Partial<Dependencies> }>(
  "educationalAdvisor/externalTeacher/update",
  async (body, { extra: { educationalAdvisorRepository } }) => {
    await educationalAdvisorRepository!.updateExternalTeacher(body);
  },
);
